import axios from 'axios';
import { REQUEST, SUCCESS, FAILURE } from '../../../../shared/reducers/action-type.util';
import { Storage } from 'react-jhipster';
import { any } from 'prop-types';
import { pageSize, IND } from 'app/config/constants';

export const ACTION_TYPES = {
  GET_DATA_HISTORY: 'History/GET_DATA_HISTORY'
};

const initialState = {
  loading: false,
  listHistory: {} as any
};

export type HistorymanagerState = Readonly<typeof initialState>;

// Reducer
export default (state: HistorymanagerState = initialState, action): HistorymanagerState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_DATA_HISTORY):
      return {
        ...state
      };
    case REQUEST(ACTION_TYPES.GET_DATA_HISTORY):
      return {
        ...state,
        loading: true
      };
    case SUCCESS(ACTION_TYPES.GET_DATA_HISTORY):
      return {
        ...state,
        listHistory: action.payload.data,
        loading: false
      };
    case FAILURE(ACTION_TYPES.GET_DATA_HISTORY):
      return {
        ...state,
        listHistory: {},
        loading: false
      };
    default:
      return state;
  }
};

const apiUrlAdmin = '/management/manager';

export const getListHistory = (page, search) => ({
  type: ACTION_TYPES.GET_DATA_HISTORY,
  payload: axios.get(`${apiUrlAdmin}/manipulations`, {
    params: {
      page: page - 1,
      size: pageSize,
      search: search
    }
  })
});

export const searchHistory = (page, search, date) => ({
  type: ACTION_TYPES.GET_DATA_HISTORY,
  payload: axios.get(`${apiUrlAdmin}/manipulations`, {
    params: {
      page: page - 1,
      size: pageSize,
      search: search,
      date: date
    }
  })
});
